<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <p class="page_title">스트레스 케어</p>
                <div class="board_wrap bo_view_layer">
                    <div class="bo_cate">
                        <span :class="state.selectCategoryIdx === category.idx ? 'active' : ''"
                            v-for="(category) in category.list">
                            {{ category.name }}
                        </span>
                    </div>
                    <div class="bo_view">
                        <div class="bo_view_tit">
                            <span class="tit" v-html="content.title"></span>
                            <span class="info"> {{ content.date }} <b>|</b> 조회수 : {{ numberFormat(content.cntRead)
                                }}</span>
                        </div>
                        <div class="bo_view_content">
                            <p style="margin-bottom: 20px" v-html="content.content"></p>
                            <div class="bo_video"
                                v-if="content.youtubeLink && content.youtubeLink !== '' && content.youtubeLink !== null">
                                <iframe width="100%" height="100%" :src="content.youtubeLink" frameborder="0"
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                        <div class="bo_gb_btns">
                            <button type="button" class="good_btn" @click="pushLike"
                                :class="state.isLike === true ? 'active' : ''">
                                <img src="@/assets/user/good_ico.png" class="off" alt="" />
                                <img src="@/assets/user/good_ico_on.png" class="on" alt="" />
                                <span>좋아요 [{{ content.cntLike }}]</span>
                            </button>
                            <button type="button" class="bad_btn" @click="pushBad"
                                :class="state.isBad === true ? 'active' : ''">
                                <img src="@/assets/user/bad_ico.png" class="off" alt="" />
                                <img src="@/assets/user/bad_ico_on.png" class="on" alt="" />
                                <span>싫어요 [{{ content.cntBad }}]</span>
                            </button>
                        </div>
                    </div>
                    <div class="bo_view_btns">
                        <router-link to="#" v-if="content.prevIdx !== null" class="prev"
                            @click="goDetail(content.prevIdx)">
                            <img src="@/assets/user/bo_arrow_l.png" />
                            이전 글
                        </router-link>
                        <router-link to="#" class="list" @click="backToList"> 목록 </router-link>
                        <router-link to="#" v-if="content.nextIdx !== null" class="next"
                            @click="goDetail(content.nextIdx)">
                            다음 글
                            <img src="@/assets/user/bo_arrow_r.png" />
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :content="modal.content" @close="modalClose"> </ModalComponent>
</template>
<script lang="ts" config>
import {
    res,
    HeaderLayout,
    GnbLayout,
    ModalComponent,
    apiService,
    globalStore,
    onMounted,
    reactive,
    router,
    useRoute,
    watch,
    numberFormat,
    formatDate,
} from "@/BaseComponent";
export default {
    components: {
        HeaderLayout,
        GnbLayout,
        ModalComponent,
    },
    setup() {
        const route = useRoute();
        const global = globalStore();
        const state = reactive({
            data: {} as any,
            idx: route.params.idx as any,
            selectCategoryIdx: 0 as number,
            modalContent: "" as string,
            isModalOpen: false as boolean,
            isNavOpen: true as boolean,
            isLike: false as boolean,
            isBad: false as boolean,
        });
        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });
        const content = reactive({
            title: "" as string,
            date: "" as string,
            content: "" as any,
            youtubeLink: "" as string,
            titleImg: "" as string,
            cntLike: 0 as number,
            cntBad: 0 as number,
            cntRead: 0 as number,
            prevIdx: 0 as number | null,
            prevTitle: "" as string | null,
            nextIdx: 0 as number | null,
            nextTitle: "" as string | null,
        });
        const category = reactive({
            list: [] as any,
        });

        onMounted(() => {
            state.isNavOpen = global.isNavOpen;
            getCategory();
            getDetail(state.idx);
        });

        watch(route, () => {
            state.idx = route.params.idx;
            getDetail(state.idx);
        });

        const getCategory = async () => {
            let res: res = await apiService.stressCare.getCategory();
            if (res.returnCode === 0) {
                category.list = res.list;
            } else {
                modal.content = res.description;
                state.isModalOpen = true;
            }
        };

        const getDetail = async (idx: number) => {
            const res = await apiService.stressCare.getDetail(idx);
            if (res.returnCode === 0) {
                content.title = res.data.title;
                content.date = formatDate(res.data.updateDate || res.data.createDate);
                content.content = res.data.content;
                content.cntLike = res.data.cntGood;
                content.cntBad = res.data.cntBad;
                content.cntRead = res.data.cntRead;
                state.isLike = res.data.isGood;
                state.isBad = res.data.isBad;
                content.youtubeLink = res.data.youtubeLink;
                content.titleImg = res.data.thumbnail;
                content.prevIdx = res.data.prev ? res.data.prev.idx : null;
                content.prevTitle = res.data.prev ? res.data.prev.title : null;
                content.nextIdx = res.data.next ? res.data.next.idx : null;
                content.nextTitle = res.data.next ? res.data.next.title : null;
                state.selectCategoryIdx = res.data.categoryVO.idx;
            } else {
                router.push("/stressCare/list/category");
            }
        };

        const backToList = () => {
            router.push("/stressCare/list");
        };

        const pushLike = async () => {
            const res = await apiService.stressCare.like(state.idx);
            if (res.returnCode === 0) {
                if (state.isLike === true) {
                    content.cntLike--;
                    state.isLike = !state.isLike;
                } else if (state.isLike === false) {
                    content.cntLike++;
                    state.isLike = !state.isLike;
                }
            }
        };
        const pushBad = async () => {
            const res = await apiService.stressCare.bad(state.idx);
            if (res.returnCode === 0) {
                if (state.isBad === true) {
                    content.cntBad--;
                    state.isBad = !state.isBad;
                } else if (state.isBad === false) {
                    content.cntBad++;
                    state.isBad = !state.isBad;
                }
            }
        };
        const goDetail = (idx: number | null) => {
            router.replace(`/stressCare/detail/${idx}`);
        };

        const modalClose = () => {
            state.isModalOpen = false;
        };

        return {
            state,
            modal,
            content,
            category,
            router,
            backToList,
            pushLike,
            pushBad,
            goDetail,
            modalClose,
            numberFormat,
        };
    },
};
</script>
